import IBlog from "../interfaces/models/blog.interface";

export const blogs: IBlog[] = [
  {
    id: 1,
    title: "blogsConstant/t-01",
    picture:
      "https://cdn.1cdn.app/application/LOUISEBOT/23092708594719_Blog_post_3.jpg",
    header: "Header 1",
    content: [
      "blogsConstant/des-01-1",
      "blogsConstant/des-01-2",
      "blogsConstant/des-01-3",
      "blogsConstant/des-01-4"
    ]
  },
  {
    id: 2,
    title: "blogsConstant/t-02",
    picture:
      "https://cdn.1cdn.app/application/LOUISEBOT/23092708594735_Blog_post_2.jpg",
    header: "Header 1",
    content: [
      "blogsConstant/des-02-1",
      "blogsConstant/des-02-2",
      "blogsConstant/des-02-3",
      "blogsConstant/des-02-4"
    ]
  },
  {
    id: 3,
    title: "blogsConstant/t-03",
    picture:
      "https://cdn.1cdn.app/application/LOUISEBOT/23092708594754_Blog_post_1.jpg",
    header: "Header 1",
    content: [
      "blogsConstant/des-03-1",
      "blogsConstant/des-03-2",
      "blogsConstant/des-03-3",
      "blogsConstant/des-03-4"
    ]
  }
];
